<template>
  <div class="tw-flex tw-gap-[18px]">
    <!-- ссылка на эфир -->
    <a
      v-if="isBroadcasting"
      :href="broadcastingLink"
      class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-text-white hover:tw-text-lightText tw-text-center tw-group"
    >
      <img
        :src="require(`@/assets/header-icons/1.svg`)"
        class="tw-h-[24px] tw-mb-[8px]"
      />
      {{ dataLang?.["alert_text_67"] }}
      <div
        class="tw-w-[24px] tw-h-[2px] tw-bg-lightText tw-absolute tw-bottom-[9px] tw-opacity-[0] group-hover:tw-opacity-[1] tw-duration-200"
      ></div>
    </a>
    <!-- ссылка на эфир -->
    <!-- главная -->
    <router-link
      :to="{ path: `/welcome` }"
      class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-text-white hover:tw-text-lightText tw-truncate tw-text-center tw-group"
    >
      <img
        :src="require(`@/assets/header-icons/2.svg`)"
        class="tw-h-[24px] tw-mb-[8px]"
      />
      Главная
      <div
        class="tw-w-[24px] tw-h-[2px] tw-bg-lightText tw-absolute tw-bottom-[9px] tw-opacity-[0] group-hover:tw-opacity-[1] tw-duration-200"
      ></div>
    </router-link>
    <!-- главная -->
    <!-- За слово -->
    <router-link
      :to="{ path: `/referal` }"
      class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-text-white hover:tw-text-lightText tw-truncate tw-text-center tw-group"
    >
      <div
        class="tw-bg-[#2E528C] tw-text-lightText tw-py-[5px] tw-px-[7px] tw-rounded-[5px] tw-mb-[8px] tw-leading-[14px] tw-truncate"
      >
        1 млн ₽
      </div>
      За слово
      <div
        class="tw-w-[24px] tw-h-[2px] tw-bg-lightText tw-absolute tw-bottom-[9px] tw-opacity-[0] group-hover:tw-opacity-[1] tw-duration-200"
      ></div>
    </router-link>
    <!-- За слово -->
    <!-- DEP.RENT -->
    <div
      _href="https://dep.rent/"
      target="_blank"
      class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-text-white hover:tw-text-lightText tw-truncate tw-text-center tw-group"
    >
      <div
        class="tw-bg-[#2E528C] tw-text-lightText tw-pt-[4px] tw-pb-[5px] tw-px-[6px] tw-rounded-[5px] tw-mb-[8px] tw-leading-[14px] tw-truncate"
      >
        <img
          :src="require(`@/assets/header-icons/dep-rent.svg`)"
          class="tw-h-[14px] tw-ml-[1px]"
        />
      </div>
      <div class="tw-font-semibold">DEP.RENT</div>
      <div
        class="tw-w-[24px] tw-h-[2px] tw-bg-lightText tw-absolute tw-bottom-[9px] tw-opacity-[0] group-hover:tw-opacity-[1] tw-duration-200"
      ></div>
    </div>
    <!-- DEP.RENT -->
    <!-- поставщики -->
    <router-link
      :to="{ path: `/products` }"
      class="tw-flex tw-justify-center tw-items-center tw-flex-col tw-text-white hover:tw-text-lightText tw-truncate tw-text-center tw-group"
    >
      <img
        :src="require(`@/assets/header-icons/5.svg`)"
        class="tw-h-[24px] tw-mb-[8px]"
      />
      Поставщики
      <div
        class="tw-w-[24px] tw-h-[2px] tw-bg-lightText tw-absolute tw-bottom-[9px] tw-opacity-[0] group-hover:tw-opacity-[1] tw-duration-200"
      ></div>
    </router-link>
    <!-- поставщики -->
  </div>
</template>
<script>
export default {
  props: ["isBroadcasting", "broadcastingLink", "dataLang"],
};
</script>
